module.exports = __webpack_public_path__ + "img/nigeria-flag.39584736.svg";